export default __webpack_public_path__ + "_/images/gamer-logo-ab24f04143536447ef4aee36e083658a06adc3c26e3de97222f49e60b8a301c3.svg";